export default __webpack_public_path__ + "80818a399be4ac4bb5f833fcba0116b2.pdf";